import type { ConstructorPlan } from './constructorTypes'
import { WORKFLOW_CHECKPOINT_KEYS } from './workflowCheckpoint'

export function isAiComposedPlan(plan: ConstructorPlan): boolean {
  if (plan.is_ai_composed) return true
  const cp = plan.workflow_checkpoints?.[WORKFLOW_CHECKPOINT_KEYS.planDiagnosticsBeta]
  if (!cp) return false
  if (cp.applied_mis_plan_id) return true
  if (plan.mis_plan_id && (cp.step === 'applied' || cp.step === 'done')) return true
  return false
}

export function isOrphanEmptyAiPlan(plan: ConstructorPlan): boolean {
  const cp = plan.workflow_checkpoints?.[WORKFLOW_CHECKPOINT_KEYS.planDiagnosticsBeta]
  if (!cp) return false
  if (plan.mis_plan_id) return false
  if ((plan.total_amount ?? 0) > 0) return false
  const failed = cp.step === 'compose_failed' || cp.step === 'error' || cp.step === 'cleared'
  const emptyProposal = !cp.proposal && !cp.proposal_id
  return failed && emptyProposal
}

export function filterVisibleConstructorPlans(plans: ConstructorPlan[]): ConstructorPlan[] {
  return plans.filter((plan) => !isOrphanEmptyAiPlan(plan))
}
